import React from 'react';
import {Dinheiro} from '@contentsys/contentsys-react-components';

import './styles/totalBar.scss';

import {Row} from 'antd';

const Valor = (props) => {
    const {children, tipo} = props

    let valor = children;
    if(tipo == "dinheiro"){
        valor = <Dinheiro value={children}></Dinheiro>
    }
    
    return (
        <div  className="valor">
            {valor}            
        </div>
    );
};

export {Valor};